import * as React from "react";
import "../Styles/style.css";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Failed from "../../images/payment-failed-icon.png";
import Button from "@mui/material/Button";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const BidRejected = ({ open, onClose, response }) => {
  const history = useHistory();
  const LoginOpen = () => {
    history.push("/become-a-member");
  };

  return (
    <>
      <Modal
        open={open}
        onClose={onClose}
        disableAutoFocus={true}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="Fw-popups"
      >
        <Box className="md-modal position-relative p-3 p-md-4">
          <div className="modalBody_area successBox  px-2 text-center ">
            <img src={Failed} className="mb-4" alt="Failed" srcSet={Failed} />
            <h4 className="pb-2 fs-4 ">{response}</h4>
            <Button
              onClick={LoginOpen}
              variant="contained"
              className="py-2 px-4 mt-3 color-white fw-700 bgSecondary  text-capitalize"
            >
              Please Become a Member
            </Button>
          </div>
        </Box>
      </Modal>
    </>
  );
};

export default BidRejected;
